import { render, staticRenderFns } from "./ItemSuggestedEventCard.vue?vue&type=template&id=4ba15747&scoped=true&lang=pug&"
import script from "./ItemSuggestedEventCard.vue?vue&type=script&lang=js&"
export * from "./ItemSuggestedEventCard.vue?vue&type=script&lang=js&"
import style0 from "./ItemSuggestedEventCard.vue?vue&type=style&index=0&id=4ba15747&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba15747",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VIcon,VImg})
